export default __webpack_public_path__ + "static/media/ElSalvador.bdee9abd.jpeg";